import React, { PureComponent } from 'react'
import axios from 'axios'
import { Row, Col, Card, CardHeader, CardBody, CardFooter } from 'reactstrap'
import LoaderSpinner from '../Widgets/LoaderSpinner'
import FlagItem from '../Components/FlagItem'
import FlagActionButtons from '../Components/FlagActionButtons'
import authProtection from '../../HOCs/authProtection'
import withAlertTimeout from '../../HOCs/withAlertTimeout'
import Alert from '../Widgets/Alert'
import FlagData from '../Components/FlagData'
import FlagCommentsModal from '../Components/FlagCommentsModal'

class Flags extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isFetching: false,
      submitting: false,
      selectedFlags: null,
      items: []
    }

    this.clearFlagsForItem = this.clearFlagsForItem.bind(this)
    this.deleteFlaggedItem = this.deleteFlaggedItem.bind(this)
    this.onViewCommentsClick = this.onViewCommentsClick.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  componentDidMount() {
    this.setState({ isFetching: true })
    this.fetchFlaggedItems()
  }

  fetchFlaggedItems() {
    const token = sessionStorage.getItem('token')
    const headers = { Authorization: `Bearer ${token}` }
    axios
      .get('/api/proxy/v2/flags/objects', { headers })
      .then(({ data }) => {
        this.setState({ items: data, isFetching: false })
      })
      .catch(err => {
        console.log(err)
        this.setState({ isFetching: true })
      })
  }

  onViewCommentsClick(flags) {
    return () => {
      this.setState({ selectedFlags: flags })
    }
  }

  renderItems() {
    return this.state.items.map(item => {
      const flagsWithComments = item.flags.filter(flag => flag.comment)
      let key = null
      switch (item.gnObjectAttached.type) {
        case 'experience':
          key = item.gnObjectAttached.gnObject.experience.id
          break
        case 'user':
          key = item.gnObjectAttached.gnObject.user.id
          break
        default:
          key = item.gnObjectAttached.gnObject.id
          break
      }
      return (
        <FlagItem
          key={key}
          type={item.gnObjectAttached.type}
          gnObject={item.gnObjectAttached.gnObject}
        >
          <FlagData
            id={item.gnObjectAttached.gnObject.id || key}
            flags={item.flags}
          />
          <FlagActionButtons
            disabled={this.state.submitting}
            hasComments={flagsWithComments.length}
            onViewCommentsClick={this.onViewCommentsClick(flagsWithComments)}
            onIgnoreClick={this.clearFlagsForItem(
              item.gnObjectAttached.type,
              key
            )}
            onRemoveClick={this.deleteFlaggedItem(
              item.gnObjectAttached.type,
              key
            )}
          />
        </FlagItem>
      )
    })
  }

  clearFlagsForItem(gnObjectType, gnObjectId) {
    return () => {
      const token = sessionStorage.getItem('token')
      const headers = { Authorization: `Bearer ${token}` }

      this.setState({ submitting: true })

      axios({
        method: 'delete',
        url: `/api/proxy/v2/flags`,
        data: { gnObjectType, gnObjectId },
        headers
      })
        .then(({ data }) => {
          this.setState({ submitting: false })

          window.scrollTo(0, 0)
          this.props.showSuccess()
          this.fetchFlaggedItems()
        })
        .catch(err => {
          this.setState({ submitting: false })

          window.scrollTo(0, 0)
          this.props.showFailure()
          console.log(err)
        })
    }
  }

  closeModal() {
    this.setState({ selectedFlags: null })
  }

  deleteFlaggedItem(gnObjectType, gnObjectId) {
    return () => {
      const token = sessionStorage.getItem('token')
      const headers = { Authorization: `Bearer ${token}` }
      this.setState({ submitting: true })

      axios({
        method: 'delete',
        url: `/api/proxy/v2/flags/objects`,
        data: { gnObjectType, gnObjectId },
        headers
      })
        .then(({ data }) => {
          this.setState({ submitting: false })
          window.scrollTo(0, 0)
          this.props.showSuccess()
          this.fetchFlaggedItems()
        })
        .catch(err => {
          this.setState({ submitting: false })
          window.scrollTo(0, 0)
          this.props.showFailure()
          console.log(err)
        })
    }
  }

  render() {
    return [
      <FlagCommentsModal
        key="modal"
        isOpen={this.state.selectedFlags !== null}
        flags={this.state.selectedFlags}
        close={this.closeModal}
      />,
      <div key="page" className="animated fadeIn">
        {<Alert active={this.props.success} message="Action successful" />}
        {
          <Alert
            type="danger"
            active={this.props.failure}
            message="Something went wrong, please try again"
          />
        }
        <Row>
          <Col xs="12">
            <Card>
              <CardHeader>Flagged Items</CardHeader>

              <CardBody>
                {this.state.isFetching && <LoaderSpinner />}
                <Row>{this.renderItems()}</Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    ]
  }
}

export default authProtection(withAlertTimeout(Flags))



// WEBPACK FOOTER //
// ./src/views/Pages/Flags.js